import { VisitaInfo } from "../../../../types/visitas";
import { TextValueContainer } from "src/components/ui/TextValueContainer";
import EditRoundedIcon from '@mui/icons-material/EditRounded';

interface Props {
    visita: VisitaInfo;
    onEditButton?: () => void;
}

export function VisitDetailsInfo({ visita, onEditButton }: Props) {
    return (
        <div>
            <div className="flex justify-between">
                <p className="font-semibold text-lg pb-2">Información de la visita</p>

                {!visita.terminado && (
                <div 
                    className="hover:bg-gray-100 rounded-md w-[25px] h-[25px] flex justify-center items-center cursor-pointer"
                    onClick={onEditButton}>
                    <EditRoundedIcon sx={{ height: 20, width: 20, color: "#4b5563"}}/>
                </div>
                )}
            </div>

            <div className="flex gap-x-3 justify-between">
                <TextValueContainer
                    text={visita?.fecha}
                    label="Fecha"/>

                <TextValueContainer
                    text={visita?.horaInicio}
                    label="Hora de inicio"/>

                <TextValueContainer
                    text={visita?.horaFin}
                    label="Hora de fin"/>
            </div>

            <div className="grid grid-cols-1 gap-x-2">
                <TextValueContainer
                    text={visita.turno}
                    label="Turno"/>
            </div>
        </div>
    );
}
